import React from 'react';
import styled from 'styled-components';
import dt from '../../../../shared/theme';
import PerformanceFeeCharged from '../../../fund/fund-components/fees-and-pricing-components/performance-fee-charged';
import {
  Fact,
  Title,
  Value,
} from './styles';

const SValue = styled(Value)`
  & > [class^="performance-fee-charged"] {
    height: 20px;
    padding: 0 8px;
    font-size: 13px;
    line-height: 12px;
    margin-top: 8px;
    margin-left: auto;

    ${props => dt(props).theme.isMobileOrTablet && `
      height: 16px;
      padding: 0 5px;
      font-size: 11px;
      line-height: 7px;
      margin-left: 0;
      border-radius: 3px;
    `}
  }
`;

export default function NoPerformanceFee() {
  return (
    <Fact>
      <Title>Actual Performance Fee</Title>
      <SValue>
        <PerformanceFeeCharged isPerformanceFeeCharged={false} />
      </SValue>
    </Fact>
  );
}
